import axios from "axios";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { NotificationManager } from "react-notifications";
import dollor from "../../../assets/icons/dollar.svg";
import percentage from "../../../assets/icons/percentage.svg";
import SearchDropdown from "../../../components/Dropdowns/SearchDropdown";
import InputWithIcon from "../../../components/InputWithIcon";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";

const AddPropertyHistoryData = ({
  handleSubmit,
  clearError,
  formData,
  onSetFormData,
  error,
  handleCancel,
  isModalOpen,
  propertyId, // ✅ added
}) => {
  const [config] = useAuth();
  const [onbuyerOptions, onSetBuyerOptions] = useState([]);
  const [onsellerOptions, onSetSellerOptions] = useState([]);

  // ✅ Fetch property details when modal opens
  useEffect(() => {
    if (isModalOpen && propertyId) {
      fetchPropertyDetails(propertyId);
    }
  }, [isModalOpen, propertyId]);

  const fetchPropertyDetails = async (propertyId) => {
    try {
      console.log("Fetching property-getbyid for:", propertyId);
      const res = await axios.post(`${BASE_URL}/property-getbyid/${propertyId}`, {}, config);
      const propertyData = res.data?.data || {};
      console.log(propertyData)
      if (propertyData?.owner_info_type === "company" && propertyData?.owner) {
        onSetFormData((prev) => ({
          ...prev,
          owner_type: "company",
          company: propertyData.owner?.name,
          owner_company_id: propertyData.owner?.id,
          seller: null,
          seller_id: null,
        }));
        fetchSeller("", propertyData.owner_company_id); // Fetch related contacts
      } else if (propertyData?.owner_info_type === "contact" && propertyData?.owner) {
        onSetFormData((prev) => ({
          ...prev,
          owner_type: "contact",
          company: "",
          seller: {
            id: propertyData.owner?.id,
            name: propertyData.owner?.name,
          },
          seller_id: propertyData.owner?.id,
        }));
      } else {
        onSetFormData((prev) => ({
          ...prev,
          owner_type: null,
          company: "",
          seller: null,
          seller_id: null,
        }));
      }
    } catch (err) {
      console.error("Error fetching property details:", err);
      NotificationManager.error("Failed to fetch property details");
    }
  };

  const fetchBuyer = (inputValue) => {
    axios
      .get(`${BASE_URL}/get-datalisting?list=acquisition&search=${inputValue}`, config)
      .then((res) => {
        const leads = res.data?.data?.leads || [];
        const options = leads.map((el) => ({
          label: `${el?.contact_name_full}`,
          value: el?.id,
          contact_id: el?.contact_id,
          contact_name: el?.contact_name_full,
        }));
        onSetBuyerOptions(options);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const fetchSeller = (inputValue, companyId = null) => {
    let apiUrl = `${BASE_URL}/get-datalisting?list=contacts&search=${inputValue}`;
    if (companyId) {
      apiUrl += `&company_id=${companyId}`;
    }
    axios
      .get(apiUrl, config)
      .then((res) => {
        const sellers = res.data?.data?.contact_list || [];
        const options = sellers.map((el) => ({
          label: `${el?.first_name} ${el?.last_name}`.trim(),
          value: el?.id,
        }));
        onSetSellerOptions(options);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const handleChange = (value, name) => {
    onSetFormData({ ...formData, [name]: value });
  };
  console.log(formData)
  return (
    <form className="py-3" onSubmit={handleSubmit}>

      {/* Sold Date */}
      <div className="flex-1 mt-3">
        <div className="w-[100%] mt-6 md:mt-0">
          <label className="dark-H head-4 mb-2">Sold Date</label>
          <DatePicker
            className="body-N"
            dateFormat="MM/dd/yyyy"
            placeholderText="MM/DD/YYYY"
            maxDate={new Date()}
            selected={formData.sold_date}
            onChange={(date) => {
              clearError("sold_date");
              handleChange(date, "sold_date");
            }}
          />
        </div>
        {error?.sold_date && <p className="body-S red-D">{error.sold_date}</p>}
      </div>

      {/* Sold Price */}
      <div className="flex-1 mt-3">
        <div className="w-[100%] md:mt-0">
          <label className="dark-H head-4 mb-2">Sold Price</label>
          <InputWithIcon
            icon={dollor}
            type="number"
            min="0"
            placeholder="Write Property Old Price"
            value={formData?.sold_price}
            onChange={(e) => {
              handleChange(e.target.value, "sold_price");
              clearError("sold_price");
            }}
            onWheel={(e) => e.target.blur()}
          />
        </div>
        {error?.sold_price && <p className="body-S red-D">{error.sold_price}</p>}
      </div>

      {/* Sold Cap Rate */}
      <div className="flex-1 mt-3">
        <div className="w-[100%] md:mt-0">
          <label className="dark-H head-4 mb-2">Sold Cap Rate</label>
          <InputWithIcon
            icon={percentage}
            type="number"
            min="0"
            placeholder="Write Property Sold Cap Rate"
            value={formData?.sold_cap_rate}
            onChange={(e) => {
              handleChange(e.target.value, "sold_cap_rate");
              clearError("sold_cap_rate");
            }}
            onWheel={(e) => e.target.blur()}
          />
        </div>
        {error?.sold_cap_rate && <p className="body-S red-D">{error.sold_cap_rate}</p>}
      </div>

      {/* Company (if company owner) */}
      {formData?.owner_type === "company" && (
        <div className="mt-5">
          <label className="dark-H head-4 mb-2">Company</label>
          <input
            className="body-N"
            name="company"
            type="text"
            placeholder="Company Name"
            value={formData.company || ""}
            readOnly
          />
          {error?.company && <span className="body-S red-D">{error?.company}</span>}
        </div>
      )}

      {/* Seller and Buyer */}
      <div className="flex gap-4 mt-5">
        <div className="w-[50%]">
          <label className="dark-H head-4 mb-2">Seller</label>

          <SearchDropdown
            placeholder="Search Seller Here"
            text={formData?.seller?.name}
            options={onsellerOptions}
            fetchSuggestions={(value) =>
              fetchSeller(value, formData?.owner_company_id || null)
            }
            onSetOptions={(value) => onSetSellerOptions(value)}
            handleSelect={(option) => {
              onSetFormData({
                ...formData,
                seller_id: option?.value,
                seller: {
                  id: option?.value,
                  name: option?.label,
                },
              });
              onSetSellerOptions([]);
            }}
          />

          {error?.seller && <span className="body-S red-D">{error?.seller}</span>}
        </div>

        <div className="w-[50%]">
          <label className="dark-H head-4 mb-2">Buyer</label>
          <SearchDropdown
            placeholder="Search Buyer Here"
            text={formData?.buyer?.name}
            options={onbuyerOptions}
            fetchSuggestions={fetchBuyer}
            onSetOptions={(value) => onSetBuyerOptions(value)}
            handleSelect={(option) => {
              onSetFormData({
                ...formData,
                buyer_id: option?.value,
                buyer: {
                  id: option?.value,
                  name: option?.label,
                  contact_id: option?.contact_id,
                  contact_name: option?.contact_name,
                },
              })
              onSetBuyerOptions([])
            }}
          />
          {error?.buyer && <span className="body-S red-D">{error?.buyer}</span>}
        </div>
      </div>

      {/* Buttons */}
      <div className="mt-6">
        <button type="submit" className="save-button light-L head-5 w-50 green-bg-H">
          Save
        </button>
        <button type="button" onClick={handleCancel} className="green-H ml-5">
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddPropertyHistoryData;
